/* @flow */

import * as React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
// TODO: No def for this.
// $FlowFixMe
import debounce from 'lodash.debounce';
import {
  Button,
  // $FlowFixMe
} from '@bijie/react-bnb';
import FlexBox from './FlexBox';
import Icon from './Icon';
import zIndexScale from '../utils/zIndexScale';

const ModalBox = styled(FlexBox)`
  width: ${({ area }) => area[0] || 'auto'};
  height: ${({ area }) => area[1] || 'auto'};
  background: ${({ theme }) => theme.buttonbg || '#fff'};
  border-radius: 4px;

`;

const ModalTitle = styled(FlexBox)`
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  line-height: 30px;
  padding: 10px 15px;
  background: ${({ theme }) => theme.boxheadbg};
  color: ${({ theme }) => theme.fontColor};
  font-size: 14px;
`;

const ModalFooter = styled(FlexBox)`
  box-sizing: border-box;
  width: 100%;
  padding: 0 15px 15px;
`;

const ModalContent = styled(FlexBox)`
  color: ${({ theme }) => theme.fontColor};
  padding: 25px 15px;
  box-sizing: border-box;
  width: 100%;
  text-align: center;
`;

const ModalCloseBtn = styled.span`
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 5px;
  .iconfont {
    color: ${({ theme }) => theme.fontColor};
  }
`;

// const Button = styled.button`
//   padding: 6px 12px;
//   font-size: 12px;
//   color: ${({ type, theme }) => type === 'ok' ? theme.fontColor4 : theme.fontColor};
//   background: ${({ type, theme }) => type === 'ok' ? theme.okButtonBg : theme.cancelButtonBg};
//   border: 1px solid ${({ type, theme }) => type === 'ok' ? theme.okButtonBg : theme.border1};
//   cursor: pointer;
//   min-width: 80px;
//   margin: 0 15px;
//   outline: none;
// `;

export type Props = {
  children?: number | string | React.Element<*> | Array<any>,
  hideModal?: Function,
  confirm?: Function,
  area?: Array<any>,
  title?: string,
  okText?: string,
  cancelText?: string,
  type?: string,
  closeBtn?: boolean,
  iconType?: string,
  onHideModal?: Function,
};

export default
class MyModal extends React.PureComponent<Props> {
  static defaultProps = {
    children: null,
    area: [],
    title: '',
    okText: 'ok',
    cancelText: 'cancel',
    hideModal: () => {},
    confirm: () => {},
    type: '',
    closeBtn: true,
    iconType: '',
    onHideModal: () => {},
  };

  _close = () => {
    this.props.hideModal &&
      this.props.hideModal();
    this.props.onHideModal &&
      this.props.onHideModal();
  }

  _confirm = () => {
    this.props.confirm && this.props.confirm();
  }

  render() {
    const customStyles = {
      content: {
        'top': '50%',
        'left': '50%',
        'right': 'auto',
        'bottom': 'auto',
        'marginRight': '-50%',
        'transform': 'translate(-50%, -50%)',
        'padding': '0',
        'border': 'none',
        'fontSize': '110%',
        'background': 'none',
        'borderRadius': '0',
      },
      overlay: {
        'background': 'rgba(0,0,0,0.3)',
        'zIndex': `${zIndexScale.modal}`,
      },
    };
    const {
      children,
      area,
      title,
      okText,
      cancelText,
      type,
      closeBtn,
      iconType,
    } = this.props;
    return (
      <Modal ariaHideApp={false} style={customStyles} {...this.props}>
        <ModalBox area={area}>
          {closeBtn ? (
            <ModalCloseBtn onClick={this._close}>
              <Icon type="close-strong" size={14} color="#999" />
            </ModalCloseBtn>) : null}

          {title ? (
            <ModalTitle>
              {title}
            </ModalTitle>) : null}

          <ModalContent justify="center">
            {iconType ? <Icon type={iconType} size={36} /> : null}
            {children}
          </ModalContent>
          {type === 'confirm' ? (
            <ModalFooter justify="center">
              <Button size="lg" onClick={this._close}>{cancelText}</Button>
              <Button
                size="lg"
                type="primary"
                style={{ marginLeft: '10px' }}
                onClick={debounce(this._confirm, 3000, {
                  'leading': true,
                  'trailing': false,
                })}
              >
                {okText}
              </Button>
            </ModalFooter>) : null}
        </ModalBox>
      </Modal>
    );
  }
}
